export default __webpack_public_path__ + "assets/1.b609d7f8.png";